module.exports = __webpack_public_path__ + "img/qr_android.1f03e6e5.png";